import { Box } from '@mui/material';

 export const EmptyComponent = () => {
    return (
        <Box sx={{
            display:'flex',
            height:'400px',
            boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
            justifyContent:'center',
            alignItems:'center'
        }}>
            Não há dados nesse período
        </Box>
    );
}